import React from 'react';
import clsx from 'clsx';
import {
  AcademicCapIcon,
  ArrowDownTrayIcon,
  ArrowPathIcon,
  ArrowRightIcon,
  ArrowTrendingUpIcon,
  BanknotesIcon,
  BeakerIcon,
  BellAlertIcon,
  BoltIcon,
  BookOpenIcon,
  BuildingStorefrontIcon,
  CakeIcon,
  CalendarIcon,
  CameraIcon,
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  CheckBadgeIcon,
  CheckCircleIcon,
  CheckIcon,
  ClockIcon,
  CreditCardIcon,
  CubeIcon,
  CurrencyDollarIcon,
  DevicePhoneMobileIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  EyeIcon,
  FaceSmileIcon,
  FireIcon,
  GiftIcon,
  GlobeAltIcon,
  HandThumbUpIcon,
  HeartIcon,
  KeyIcon,
  LifebuoyIcon,
  LightBulbIcon,
  LockClosedIcon,
  MapPinIcon,
  MegaphoneIcon,
  MoonIcon,
  MusicalNoteIcon,
  PaintBrushIcon,
  PhoneIcon,
  PlusIcon,
  PuzzlePieceIcon,
  ReceiptPercentIcon,
  RocketLaunchIcon,
  ScaleIcon,
  ShieldCheckIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
  SparklesIcon,
  StarIcon,
  SunIcon,
  TagIcon,
  TicketIcon,
  TrophyIcon,
  TruckIcon,
  UserGroupIcon,
  VideoCameraIcon,
  WrenchScrewdriverIcon,
  XMarkIcon,
} from '@heroicons/react/20/solid';

export const BADGE_ICONS = {
  star: StarIcon,
  sparkles: SparklesIcon,
  fire: FireIcon,
  bolt: BoltIcon,
  rocket: RocketLaunchIcon,
  trophy: TrophyIcon,
  check: CheckIcon,
  'x-mark': XMarkIcon,
  plus: PlusIcon,
  'arrow-right': ArrowRightIcon,
  'check-badge': CheckBadgeIcon,
  'check-circle': CheckCircleIcon,
  'shield-check': ShieldCheckIcon,
  'thumbs-up': HandThumbUpIcon,
  heart: HeartIcon,
  smile: FaceSmileIcon,
  'light-bulb': LightBulbIcon,
  sun: SunIcon,
  moon: MoonIcon,
  gift: GiftIcon,
  tag: TagIcon,
  percent: ReceiptPercentIcon,
  dollar: CurrencyDollarIcon,
  banknotes: BanknotesIcon,
  'credit-card': CreditCardIcon,
  'shopping-bag': ShoppingBagIcon,
  'shopping-cart': ShoppingCartIcon,
  truck: TruckIcon,
  clock: ClockIcon,
  calendar: CalendarIcon,
  bell: BellAlertIcon,
  megaphone: MegaphoneIcon,
  'trending-up': ArrowTrendingUpIcon,
  chart: ChartBarIcon,
  refresh: ArrowPathIcon,
  lock: LockClosedIcon,
  key: KeyIcon,
  ticket: TicketIcon,
  users: UserGroupIcon,
  'academic-cap': AcademicCapIcon,
  book: BookOpenIcon,
  music: MusicalNoteIcon,
  video: VideoCameraIcon,
  document: DocumentTextIcon,
  download: ArrowDownTrayIcon,
  mobile: DevicePhoneMobileIcon,
  camera: CameraIcon,
  'paint-brush': PaintBrushIcon,
  puzzle: PuzzlePieceIcon,
  cube: CubeIcon,
  globe: GlobeAltIcon,
  'map-pin': MapPinIcon,
  storefront: BuildingStorefrontIcon,
  tools: WrenchScrewdriverIcon,
  beaker: BeakerIcon,
  lifebuoy: LifebuoyIcon,
  chat: ChatBubbleLeftRightIcon,
  envelope: EnvelopeIcon,
  phone: PhoneIcon,
  cake: CakeIcon,
  scale: ScaleIcon,
  eye: EyeIcon,
};

export const isBadgeIcon = key => Boolean(BADGE_ICONS[key]);

// Decorative: the badge text carries the meaning. Sized in em so it follows
// whatever font size the theme gives the badge, and coloured by currentColor
// so it takes the badge's themed text colour with no property of its own. A
// caller's className replaces the default size rather than competing with it.
export default function BadgeIcon({ icon, className = 'size-[1em] flex-none' }) {
  const Icon = BADGE_ICONS[icon];
  if (!Icon) return null;

  return (
    <Icon aria-hidden="true" data-badge-icon={icon} className={clsx('cp_badge-icon', className)} />
  );
}
